import React from 'react';
import { inject, observer } from 'mobx-react';
import { FormattedMessage, injectIntl } from 'react-intl';

import { modelOf } from '../../../prop-types';
import CampaignCodeStore from "../../../store/CampaignCodeStore";
import Icon from "../../common/Icon";
import CampaignCodeDiscount from "../CampaignCodeDiscount";
import ButtonLink from "../../common/ButtonLink";
import PropTypes from "prop-types";

const CampaignCodeActive = ({
  campaignCodeStore,
  shouldPopup,
}) => {

  const handleUnset = () => {
    campaignCodeStore
      .unsetCode()
      .then(() => {
        window.location.reload();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  return (
    <div id="CampaignCodeActive" className="CampaignCodeActive">
      <Icon name="check" className="CampaignCodeActive__icon" />
      <FormattedMessage
        id="campaign.isActivated"
        defaultMessage="The campaign code is activated!"
      />
      <CampaignCodeDiscount shouldPopup={shouldPopup} />
      <div className="CampaignCodeActive__remove-code">
        <ButtonLink
          className="RemoveCampaignCodeLink"
          onClick={handleUnset}
        >
          <FormattedMessage
            id="campaign.removeCouponCode"
            defaultMessage="Remove code"
          />
        </ButtonLink>
      </div>
    </div>
  );
}


CampaignCodeActive.propTypes = {
  campaignCodeStore: modelOf(CampaignCodeStore).isRequired,
  shouldPopup: PropTypes.bool.isRequired,
};

CampaignCodeActive.defaultProps = {
  shouldPopup: false,
};

export default inject(
  'campaignCodeStore'
)(injectIntl(observer(CampaignCodeActive)));
